module.exports = __webpack_public_path__ + "img/File-Pdf.5ba66786.svg";